import { FileTypes } from "./types";

export const setFiles = (files) => {
  return {
    type: FileTypes.SET_FILES,
    payload: files
  }
};

export const addFile = (file) => {
  return {
    type: FileTypes.ADD_FILE,
    payload: file
  }
};
